module.exports = __webpack_public_path__ + "static/img/profile.4a8ea551.jpg";